// This file is generated by .vnops/spa/load_spas.sh
const data = [
  {
    name: 'menus',
    display_name: 'Menus',
    domain: 'ordernext.com',
    subdomain: { suffix: '-menu' },
    icon: 'IconMenus',
  },
  {
    name: 'refund',
    display_name: 'Orders',
    domain: 'ordernext.com',
    subdomain: { suffix: '-refund' },
    icon: 'IconRefund',
  },
  {
    name: 'status',
    display_name: 'Status',
    domain: 'ordernext.com',
    subdomain: { suffix: '-status' },
    icon: 'IconStatus',
  },
  {
    name: 'reports',
    display_name: 'Reports',
    domain: 'ordernext.com',
    subdomain: { suffix: '-datanow' },
    icon: 'IconReports',
  },
  {
    name: 'loyalty',
    display_name: 'Loyalty',
    domain: 'ordernext.com',
    subdomain: { suffix: '-loyalty' },
    icon: 'IconLoyalty',
  },
  {
    name: 'devices',
    display_name: 'Devices',
    domain: 'ordernext.com',
    subdomain: { suffix: '-devices' },
    icon: 'IconDevices',
  },
  {
    name: 'suites',
    display_name: 'Suites',
    domain: 'ordernext.com',
    subdomain: { suffix: '-suites' },
    icon: 'IconSuites',
  },
  {
    name: 'access',
    display_name: 'Access',
    domain: 'ordernext.com',
    subdomain: { suffix: '-access' },
    icon: 'IconAccess',
  },
  {
    name: 'settings',
    display_name: 'Settings',
    domain: 'ordernext.com',
    subdomain: { suffix: '-menu' },
    icon: 'IconSettings',
    path: '/custom-tenders',
  },
]

export default data
